var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LocaleProviderx',[_c('div',{attrs:{"id":"app"},on:{"drop":_vm.drop}},[_c('RouterView'),(_vm.$store.state.app.loading)?_c('div',{staticClass:"loading-spin"},[_c('a-spin',{attrs:{"size":"large"}})],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }